import React, { useState, useEffect } from 'react';
import { axiosInstance } from '../../client';

export default function PdfViewerBlob({ 
  pdfUrl, 
  title, 
  className = "w-full h-[500px] rounded border",
  fallbackMessage = "El archivo no existe."
}) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let objectUrl;
    let cancelled = false;

    setBlobUrl(null);
    setError(false);
    setLoading(true);

    if (!pdfUrl) {
      setLoading(false);
      return;
    }

    axiosInstance.get(pdfUrl, { responseType: 'blob' })
      .then(response => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(response.data);
        setBlobUrl(objectUrl);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error al cargar el PDF:', err);
        if (!cancelled) {
          setError(true);
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [pdfUrl]);

  if (loading) {
    return (
      <div className={`flex items-center justify-center bg-gray-100 ${className}`}>
        <svg className="w-10 h-10 text-blue-600 animate-spin" viewBox="0 0 24 24" fill="none">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
        </svg>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`flex items-center justify-center bg-gray-100 ${className}`}>
        <p className="text-gray-500 font-itcbook">{fallbackMessage}</p>
      </div>
    );
  }

  return (
    <iframe
      src={blobUrl}
      title={title || "Ver PDF"}
      className={className}
    />
  );
}